import { createContext, ReactNode, useState } from "react";

export const SocketMessageContext = createContext<{
  socketMessage?: string;
  setSocketMessage: Function;
}>({ socketMessage: undefined, setSocketMessage: () => {} });

const SocketMessageProvider = ({ children }: { children: ReactNode }) => {
  const [socketMessage, setSocketMessage] = useState<string | undefined>();

  return (
    <SocketMessageContext.Provider value={{ socketMessage, setSocketMessage }}>
      {children}
    </SocketMessageContext.Provider>
  );
};

export default SocketMessageProvider;
